/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * modules.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * Import module.
*/
import { setSmoothScroll } from "./setSmoothScroll";
import { setDrawerButton } from "./setDrawerButton";
import { setAcdnToggle } from "./setAcdnToggle";
import { setMegaMenuToggle } from "./setMegaMenuToggle";
import { setSwiper } from "./setSwiper";
import { setHeaderScrollClass } from "./setHeaderScrollClass";

function addModule() {
  const html = document.documentElement;
  const body = document.body;
  const header = document.querySelector('.header');
  const flagMv = document.querySelector('.--js-flagMv');
  const getMvH = document.querySelector('.--js-getMvH');
  const allCheckBox = document.querySelectorAll('.--js-allCheckBox');

  /**
   * @name setScrollPaddingTop
   * @description アンカーリンク先に”scroll-padding-top”を設定する
   * @param {Number} headerHeight ヘッダーの高さ
   */
  function setScrollPaddingTop() {
    const init = () => {
      let headerHeight = header.clientHeight;
      html.style.scrollPaddingTop = `${headerHeight}px`;
    }
    init();
    window.addEventListener("resize", init);
  }

  /**
   * @name scrollFlagMv
   * @description 画面上部からのスクロール量を取得し、MVの高さの半分を超えたらtrueを返す
   */
  const scrollFlagMv = () => {
    let flagMvTop = flagMv.getBoundingClientRect().height / 2;
    let scrollTop = window.pageYOffset;
    return scrollTop >= flagMvTop ? true : false;
  }

  /**
   * @name allCheckedCheckboxes
   * @description すべて選択のチェックボックスにチェックが入ったら、以降のチェックボックスにチェックを入れる
   */
  const allCheckedCheckboxes = () => {
    if (!allCheckBox) return;
    const checkToggle = (e) => {
      let parent = e.target.parentNode.parentNode;
      let checkboxes = parent.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach((checkbox) => checkbox.checked = e.target.checked);
    }
    allCheckBox.forEach((el) => el.addEventListener("change", checkToggle));
  }

  /**
   * @name transform
   * @description 呼び出した関数を実行する
   */
  const transform = () => {
    scrollFlagMv() ? toTopBtn.dataset.state = "show" : toTopBtn.dataset.state = "";
  }

  /**
   * @name getMvH
   * @description MVの高さを取得し、変数に格納する
   */
  const getMvHeight = () => {
    let mvHeight = getMvH.getBoundingClientRect().height;
    body.style.setProperty('--mvHeight', `${mvHeight}px`);
  }

  window.addEventListener("scroll", transform);
  scrollFlagMv();
  setScrollPaddingTop();
  allCheckedCheckboxes();
  getMvHeight();
  window.addEventListener("resize", getMvHeight);
}

/**
 * Do modules.
 */
export function modules() {
  setSmoothScroll();
  setDrawerButton();
  setAcdnToggle();
  setMegaMenuToggle();
  setSwiper();
  setHeaderScrollClass();
  addModule();
}